import { MOTION } from '../system/motion';
// Read by Textarea to turn a row count into a border-box min-height.
export const INPUT_BORDER_WIDTH = '1px';
export const TEXTAREA_PAD_BLOCK = 'var(--space-sm)';
export const inputBase = {
    // Block layout: textareas are inline-block by default, which leaves a
    // baseline descender gap below them. Block strips that gap so consumers
    // don't see phantom bottom space.
    display: 'block',
    // --type-input, not body: editable controls must render at 16px or iOS
    // Safari auto-zooms the page on focus (see tokens.css).
    font: 'var(--type-input)',
    color: 'var(--foreground)',
    background: 'var(--background)',
    border: `${INPUT_BORDER_WIDTH} solid var(--border-strong)`,
    borderRadius: 'var(--radius-md)',
    // A textarea's padding. The single-line controls (Input, Select) set
    // their own: Button md's height (CONTROL_HEIGHT), so a field and a button
    // in one row line up.
    padding: `${TEXTAREA_PAD_BLOCK} var(--space-md)`,
    width: '100%',
    outline: 'none',
    transition: MOTION.transition,
};
//# sourceMappingURL=inputBase.js.map